import { tblSpecAddColumn } from '../../../core/table/spec';
import { TblCol } from '../../../core/table/table.types';
import { TblViewSpec } from '../../../core/table/table-view.types';
import FormattedDateWithAMPMTimeRenderer from '../../../core/table/renderers/FormattedDateWithAMPMTimeRenderer';

/**
 * InvoiceLineItemDispensesTableSpec Column Reference
 *
 * | Category | Column Key        | Column Name      | Type    |
 * |----------|------------------|------------------|---------|
 * | Details  | CEID             | Facility         | string  |
 * | Details  | PHID             | Pharmacy Short   | string  |
 * | Details  | DispNdc          | NDC              | string  |
 * | Details  | DispDate         | Date Filled      | date    |
 * | Details  | DispQuantity     | Dispensed        | number  |
 * | Details  | BackingQuantity  | Used             | number  |
 * | Details  | PhysicianName    | Physician        | string  |
 * | Details  | DispRxNumber     | Rx #             | string  |
 * | Details  | DispRefills      | Refills          | number  |
 *
 * Notes:
 * - RXID is kept on the data type for routing (navToFeature) but is not a display column.
 * - AccumId and DispNPI are API response fields but are not displayed in Angular or React.
 */

export type ColKey =
    | 'CEID'
    | 'PHID'
    | 'DispNdc'
    | 'DispDate'
    | 'DispQuantity'
    | 'BackingQuantity'
    | 'PhysicianName'
    | 'DispRxNumber'
    | 'DispRefills';

export function invoiceLineItemDispensesColumnSpec(): Map<string, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'CEID', { type: 'TEXT', title: 'Facility' });
    tblSpecAddColumn<ColKey>(map, 'PHID', { type: 'TEXT', title: 'Pharmacy' });
    tblSpecAddColumn<ColKey>(map, 'DispNdc', { type: 'TEXT', title: 'NDC' });
    tblSpecAddColumn<ColKey>(
        map,
        'DispDate',
        { type: 'DATE', title: 'Date Filled' },
        FormattedDateWithAMPMTimeRenderer,
    );
    tblSpecAddColumn<ColKey>(map, 'DispRxNumber', { type: 'TEXT', title: 'Rx #' });
    tblSpecAddColumn<ColKey>(map, 'DispRefills', { type: 'NUMBER', title: 'Fill #' });
    tblSpecAddColumn<ColKey>(map, 'PhysicianName', { type: 'TEXT', title: 'Physician' });
    tblSpecAddColumn<ColKey>(map, 'DispQuantity', { type: 'NUMBER', title: 'Dispensed' });
    tblSpecAddColumn<ColKey>(map, 'BackingQuantity', { type: 'NUMBER', title: 'Used' });
    return map;
}

export function invoiceLineItemDispensesAllColumnsView(): TblViewSpec {
    return {
        key: 'all',
        title: 'All Columns',
        sections: [
            {
                title: 'Details',
                cols: [
                    'CEID',
                    'PHID',
                    'DispNdc',
                    'DispDate',
                    'DispRxNumber',
                    'DispRefills',
                    'PhysicianName',
                    'DispQuantity',
                    'BackingQuantity',
                ],
            },
        ],
        sortby: '-DispDate',
    };
}
